import * as openpgp from "openpgp";
import {
  clearContentKeys,
  getContentKeys,
  getContentKeysArmored,
  setContentKeys,
} from "./contentKeys";

// CIENKA NAKŁADKA na utils/contentKeys.ts (mirror kluczy treści z dwoma slotami).
//
// Mirror kluczy aktywnego profilu przestał być osobnym bytem — jest slotem 'company'
// nowego mirrora, karmionym kluczami FIRMY (utils/companyContentKeys.ts). Plik zostaje
// wyłącznie po to, żeby dotychczasowi wołający (decryptPrivateKey, decryptPackage,
// decryptFilePool, App.tsx) działali bez zmian; nowy kod ma wołać contentKeys wprost.
//
// UWAGA HISTORYCZNA: ta nakładka została raz przypadkowo cofnięta do wersji sprzed
// przebudowy (plik wrócił do własnej tablicy modułowej). Objawem było „Session key
// decryption failed" w decryptPrivateKey — mirror firmy był wypełniony, ale ta funkcja
// czytała pustą tablicę obok niego. Jeżeli te testy znów zaczną padać, sprawdź TU NAJPIERW.

/** Ustawia klucze treści → slot 'company' mirrora. */
export const setActiveProfilePrivateKeys = (keys: openpgp.key.Key[]): void =>
  setContentKeys("company", keys);

/** Czyści slot 'company'. Slotu 'guest' NIE rusza — konwersacja gościa ma własny cykl życia. */
export const clearActiveProfilePrivateKeys = (): void =>
  clearContentKeys("company");

/**
 * Klucze treści w postaci ASCII-armor — do przekazania workerowi deszyfrującemu.
 * Unia obu slotów: worker deszyfruje zarówno pliki firmy, jak i załączniki gościa.
 */
export const getActiveProfilePrivateKeysArmored = (): string[] =>
  getContentKeysArmored();

/**
 * Klucze prywatne treści (unia slotów 'company' i 'guest'). Trafiają do openpgp.decrypt
 * jako `privateKeys` — openpgp dobiera właściwy klucz po ID odbiorcy z szyfrogramu.
 * Pusta tablica = mirror niezaprimowany (wołający używa wtedy klucza intermediate jako fallbacku).
 */
export const getActiveProfilePrivateKeys = (): openpgp.key.Key[] =>
  getContentKeys();
